import axios from "axios";

const publicAxios = axios.create({
  baseURL: "https://panaccoapi-453601304730.asia-south1.run.app",
});
export default publicAxios;
